<div class="custom-page-info">
  <h1 class="custom-page-info__title">
    <ng-container>
      {{ title }}
    </ng-container>
  </h1>
</div>
